import { Tooltip } from "antd";
import { Uuid } from "components/UUID";
import React from "react";
import styled from "styled-components";
import { radius } from "@libertify/ui";

export const ScriptIndexAnchor = ({
  children,
  highlightId,
  background,
  color = "#fff",
}: {
  children: React.ReactNode;
  highlightId: string;
  background: string;
  color?: string;
  error?: boolean;
}) => {
  return (
    <WordAnchor
      style={{
        background: background,
        color,
      }}
    >
      <Tooltip
        autoAdjustOverflow
        trigger={"click"}
        title={<Uuid id={highlightId} style={{ color: "#fff" }} />}
      >
        {children}
      </Tooltip>
    </WordAnchor>
  );
};

const WordAnchor = styled.span`
  /* inline position for improved readability */
  font-size: 12px;
  padding: 2px 6px;
  border-radius: ${radius.pill}px;
  font-weight: bold;
  vertical-align: top;
  margin-right: 8px;
  margin-left: 1px;
  margin-top: 0;
  display: inline-block;
  min-width: 14px;
  text-align: center;
  line-height: 1em;
`;
